import { ToastConfig } from './index'

export let bridge: {
  setConfig?: (config: ToastConfig) => any,
  closeToast?: () => any
} = {}

// 暴露给用户调用的方法
export function showToast(config: ToastConfig) {
  if (bridge.setConfig) {
    bridge.setConfig({
      closeAuto: true,
      duration: 1500,
      ...config
    })
  }
}

export function closeToast() {
  if (bridge.closeToast) {
    bridge.closeToast()
  }
}

export const defaultConfig:ToastConfig = {
  type : 'success',
  duration: 2000
}



// WEBPACK FOOTER //
// ../src/popup-layer/toast/bridge.ts